import { gql } from '@apollo/client';

export const CREATE_BULK_REDEMPTION = gql`
  mutation CreateBulkRedemption($request: [CreateRedemptionRequest!]!) {
    CreateBulkRedemption(request: $request) {
      ... on PaginationResponse {
        count
      }
      ... on Redemptions {
        data {
          id
        }
      }
    }
  }
`;

export const CREATE_REDEMPTION = gql`
  mutation CreateRedemption($request: CreateRedemptionRequest!) {
    CreateRedemption(request: $request) {
      id
    }
  }
`;
